var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
/*!
 * jQuery UI Mouse 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: https://api.jqueryui.com/mouse/

(function (factory) {
  "use strict";

  // Browser globals
  factory(jQuery);
})(function ($) {
  "use strict";

  var mouseHandled = false;
  $(document).on("mouseup", function () {
    mouseHandled = false;
  });
  return $.widget("ui.mouse", {
    version: "1.13.3",
    options: {
      cancel: "input, textarea, button, select, option",
      distance: 1,
      delay: 0
    },
    _mouseInit: function () {
      var that = this || _global;
      (this || _global).element.on("mousedown." + (this || _global).widgetName, function (event) {
        return that._mouseDown(event);
      }).on("click." + (this || _global).widgetName, function (event) {
        if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
          $.removeData(event.target, that.widgetName + ".preventClickEvent");
          event.stopImmediatePropagation();
          return false;
        }
      });
      (this || _global).started = false;
    },
    // TODO: make sure destroying one instance of mouse doesn't mess with
    // other instances of mouse
    _mouseDestroy: function () {
      (this || _global).element.off("." + (this || _global).widgetName);
      if ((this || _global)._mouseMoveDelegate) {
        (this || _global).document.off("mousemove." + (this || _global).widgetName, (this || _global)._mouseMoveDelegate).off("mouseup." + (this || _global).widgetName, (this || _global)._mouseUpDelegate);
      }
    },
    _mouseDown: function (event) {
      // don't let more than one widget handle mouseStart
      if (mouseHandled) {
        return;
      }
      (this || _global)._mouseMoved = false;

      // We may have missed mouseup (out of window)
      if ((this || _global)._mouseStarted) {
        this._mouseUp(event);
      }
      (this || _global)._mouseDownEvent = event;
      var that = this || _global,
        btnIsLeft = event.which === 1,
        // event.target.nodeName works around a bug in IE 8 with
        // disabled inputs (#7620)
        elIsCancel = typeof (this || _global).options.cancel === "string" && event.target.nodeName ? $(event.target).closest((this || _global).options.cancel).length : false;
      if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
        return true;
      }
      (this || _global).mouseDelayMet = !(this || _global).options.delay;
      if (!(this || _global).mouseDelayMet) {
        (this || _global)._mouseDelayTimer = setTimeout(function () {
          that.mouseDelayMet = true;
        }, (this || _global).options.delay);
      }
      if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
        (this || _global)._mouseStarted = this._mouseStart(event) !== false;
        if (!(this || _global)._mouseStarted) {
          event.preventDefault();
          return true;
        }
      }

      // Click event may never have fired (Gecko & Opera)
      if (true === $.data(event.target, (this || _global).widgetName + ".preventClickEvent")) {
        $.removeData(event.target, (this || _global).widgetName + ".preventClickEvent");
      }

      // These delegates are required to keep context
      (this || _global)._mouseMoveDelegate = function (event) {
        return that._mouseMove(event);
      };
      (this || _global)._mouseUpDelegate = function (event) {
        return that._mouseUp(event);
      };
      (this || _global).document.on("mousemove." + (this || _global).widgetName, (this || _global)._mouseMoveDelegate).on("mouseup." + (this || _global).widgetName, (this || _global)._mouseUpDelegate);
      event.preventDefault();
      mouseHandled = true;
      return true;
    },
    _mouseMove: function (event) {
      // Only check for mouseups outside the document if you've moved inside the document
      // at least once. This prevents the firing of mouseup in the case of IE<9, which will
      // fire a mousemove event if content is placed under the cursor. See #7778
      // Support: IE <9
      if ((this || _global)._mouseMoved) {
        // IE mouseup check - mouseup happened when mouse was out of window
        if ($.ui.ie && (!document.documentMode || document.documentMode < 9) && !event.button) {
          return this._mouseUp(event);

          // Iframe mouseup check - mouseup occurred in another document
        } else if (!event.which) {
          // Support: Safari <=8 - 9
          // Safari sets which to 0 if you press any of the following keys
          // during a drag (#14461)
          if (event.originalEvent.altKey || event.originalEvent.ctrlKey || event.originalEvent.metaKey || event.originalEvent.shiftKey) {
            (this || _global).ignoreMissingWhich = true;
          } else if (!(this || _global).ignoreMissingWhich) {
            return this._mouseUp(event);
          }
        }
      }
      if (event.which || event.button) {
        (this || _global)._mouseMoved = true;
      }
      if ((this || _global)._mouseStarted) {
        this._mouseDrag(event);
        return event.preventDefault();
      }
      if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
        (this || _global)._mouseStarted = this._mouseStart((this || _global)._mouseDownEvent, event) !== false;
        if ((this || _global)._mouseStarted) {
          this._mouseDrag(event);
        } else {
          this._mouseUp(event);
        }
      }
      return !(this || _global)._mouseStarted;
    },
    _mouseUp: function (event) {
      (this || _global).document.off("mousemove." + (this || _global).widgetName, (this || _global)._mouseMoveDelegate).off("mouseup." + (this || _global).widgetName, (this || _global)._mouseUpDelegate);
      if ((this || _global)._mouseStarted) {
        (this || _global)._mouseStarted = false;
        if (event.target === (this || _global)._mouseDownEvent.target) {
          $.data(event.target, (this || _global).widgetName + ".preventClickEvent", true);
        }
        this._mouseStop(event);
      }
      if ((this || _global)._mouseDelayTimer) {
        clearTimeout((this || _global)._mouseDelayTimer);
        delete (this || _global)._mouseDelayTimer;
      }
      (this || _global).ignoreMissingWhich = false;
      mouseHandled = false;
      event.preventDefault();
    },
    _mouseDistanceMet: function (event) {
      return Math.max(Math.abs((this || _global)._mouseDownEvent.pageX - event.pageX), Math.abs((this || _global)._mouseDownEvent.pageY - event.pageY)) >= (this || _global).options.distance;
    },
    _mouseDelayMet: function /* event */
    () {
      return (this || _global).mouseDelayMet;
    },
    // These are placeholder methods, to be overriden by extending plugin
    _mouseStart: function /* event */ () {},
    _mouseDrag: function /* event */ () {},
    _mouseStop: function /* event */ () {},
    _mouseCapture: function /* event */
    () {
      return true;
    }
  });
});
export default {};